import { Profile } from 'labxchange-client';
import * as React from 'react';
import { UserAvatar } from 'user/components';

interface UserCardCompactProps {
    profile: Profile;
    actions?: React.ReactNode;
}

export class UserCardCompact extends React.PureComponent<UserCardCompactProps> {
    public render() {
        const { profile, actions } = this.props;
        return (
            <div className='user-card-compact'>
                <div className='content'>
                    <div className='avatar'>
                        <UserAvatar
                            username={profile.username}
                            diameter='40px'
                        />
                    </div>
                    <div className='name'>
                        {profile.fullName}
                    </div>
                    {actions ? <div className='actions'>
                        {actions}
                    </div> : null}
                </div>
            </div>
        );
    }
}
